import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Attachment.module.scss';
import { ReactComponent as DocumentIcon } from './icons/document.svg';
import { ReactComponent as ExcelIcon } from './icons/excel.svg';
import { ReactComponent as WordIcon } from './icons/word.svg';
import { ReactComponent as PDFIcon } from './icons/pdf.svg';
import { ReactComponent as PPTIcon } from './icons/powerpoint.svg';
import Loader from '../../../common/Loader/Loader';

const AttachmentIcon = ({ sender, attachment }) => {
  const { attachmentFile, id, url, type, name, tempUrl } = attachment;
  const [previewImage, setPreviewImage] = useState(false);
  const sent = !id;

  const handClick = () => {
    setPreviewImage(!previewImage);
  };

  const fileViewRenderer = type => {
    if (type.includes('image') && !type.includes('svg')) {
      return <img src={url || tempUrl} alt={url} onClick={handClick} />;
    }
    if (type.includes('pdf')) {
      return <PDFIcon />;
    }
    if (type.includes('doc') && type.includes('word')) {
      return <WordIcon />;
    }
    if (type.includes('xl') || type.includes('sheet')) {
      return <ExcelIcon />;
    }
    if (type.includes('ppt')) {
      return <PPTIcon />;
    }
    return <DocumentIcon />;
  };

  const fileWithLoader = () => <Loader>{fileViewRenderer(type)}</Loader>;

  return (
    <div className={styles.fileContainer}>
      {attachmentFile && fileWithLoader()}
      {name && fileViewRenderer(type)}

      {sender === 'received' && name && !(type.includes('image') && !type.includes('svg')) && (
        <a href={url || tempUrl} download={name}>
          <div className={styles.overlayText}>
            <span>
              <i className="material-icons">arrow_downward</i>Click to Download
            </span>
          </div>
        </a>
      )}
      <div className="file-name">
        {attachmentFile && attachmentFile.name}
        {name && name}
      </div>
      {!sent && '...loading'}
      {previewImage && (
        <div className={styles.imageViewer} onClick={handClick}>
          <div className={styles.imageViewerOverlay} />
          <div className={styles.download}>
            <a href={url || tempUrl} download={name}>
              <span>
                <i className="material-icons" onClick={handClick}>
                  arrow_downward
                </i>
                Download
              </span>
            </a>
          </div>
          <div className={styles.close}>
            <i className="material-icons" onClick={handClick}>
              close
            </i>
          </div>
          <img src={url || tempUrl} alt={url} />
        </div>
      )}
    </div>
  );
};

AttachmentIcon.propTypes = {
  attachment: PropTypes.shape().isRequired,
  sender: PropTypes.string.isRequired,
};

export default AttachmentIcon;
